import React from 'react';
import SimpleProductPage from './PriceComparison/SimpleProductPage';
import { 
  findProductById, 
  getProductImage, 
  getProductCsvLookupId 
} from '../utils/productHelpers';

const BreakAwayPoleTrackAllTerrain = () => {
  console.log('🎯 BreakAwayPoleTrackAllTerrain component loading');
  
  const product = findProductById("breakaway-pole-track-all-terrain");
  
  if (!product) {
    console.error('Product not found:', "breakaway-pole-track-all-terrain");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="breakaway-pole-track-all-terrain"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
    />
  );
};

export default BreakAwayPoleTrackAllTerrain; 